
function Success() {
    return (
        <h1>Thank you for your purchase!</h1>
    )
}

export default Success;